import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { JWT_VAl } from "./Functions/jwt_validate";
import Header from "../Component/Header";
import { createCookie, deleteCookie, getCookie } from "../CookieFunctions";
import { apihost, authhost,basehost } from "../ApiHost";

const App = () => {
  const [Idea, setIdea] = useState({});
  const { Id } = useParams();
  const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState(false);

  const UnlockFunction=()=>{
    localStorage.setItem("payment_redirect",'/view/'+Id);
    navigate("/plans");
  }

  useEffect(() => {
    document.title = `InsightNest | ${Id.split("-").pop()}`;
    const fetchData = async () => {
      const JWT = await JWT_VAl();
      if (!JWT.success && !JWT.verified) {
        createCookie("loginRedirect", basehost+"/home/view/" + Id);
        window.location.href = authhost;
      }
      try {
        const response = await fetch(`${apihost}/validate/get/${Id}`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${getCookie("_JWT")}`,
          },
        });
        const result = await response.json();
        setIsSubscribed(result.isSubscribed);
        setIdea(result.Idea);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [Id, navigate]);

  if (!Idea.overallFeedback) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <>
      <Header Unlock={!isSubscribed} UnlockFun={UnlockFunction} />
      <div className="min-h-screen p-4 bg-[rgb(245_243_255)] text-gray-800">
        {/* Header */}

        {/* Main Content */}
        <div className="mt-6 space-y-8">
          {/* Summary & Suggestions */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
                Summary
              </h2>
              <p className="mt-4 text-gray-600">
                {Idea.overallFeedback.summary}
              </p>
            </div>
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
                Final Suggestions
              </h2>
              <p className="mt-4 text-gray-600">
                {Idea.overallFeedback.finalSuggestions}
              </p>
              <div className="flex items-center mt-6 space-x-6">
                <div>
                  <h3 className="text-sm font-bold text-gray-800">Rating</h3>
                  <div className="flex space-x-1 mt-1">
                    {[
                      ...Array(parseInt(Idea.overallFeedback.averageRating)),
                    ].map((_, i) => (
                      <span key={i} className="text-yellow-500">
                        ★
                      </span>
                    ))}
                    {[
                      ...Array(
                        5 - parseInt(Idea.overallFeedback.averageRating)
                      ),
                    ].map((_, i) => (
                      <span key={i} className="text-gray-300">
                        ★
                      </span>
                    ))}
                  </div>
                </div>
                <div>
                  <h3 className="text-sm font-bold text-gray-800">
                    Uniqueness Score
                  </h3>
                  <p className="text-[rgb(100_65_233)] font-semibold text-lg mt-1">
                    {Idea.overallFeedback.averageUniquenessScore}%
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Competition */}
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              Competition
            </h2>
            <p className="mt-4 text-gray-600">
              {Idea.overallFeedback.Competition.ThoughtOnCompetition}
            </p>
          </div>

          {/* Market Research */}
          <div className="p-6 bg-white shadow-lg rounded-lg">
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              Market Research
            </h2>
            <p className="mt-4 text-gray-600">
              {Idea.overallFeedback.MarketResearch.summary}
            </p>
            <div className={`flex flex-wrap mt-4 gap-2 ${!isSubscribed ? "blur-overlay" : ""}`}>
              {Idea.overallFeedback.MarketResearch.notableURLs.map(
                (link, i) => (
                  <a
                    key={i}
                    href={link}
                    className={`px-3 py-1 border border-gray-300 rounded-full text-sm text-[rgb(100_65_233)] hover:bg-[rgb(100_65_233)] hover:text-white transition-colors`}
                  >
                    {link.length > 50 ? `${link.slice(0, 47)}...` : link}
                  </a>
                )
              )}
            </div>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              List of Competitors
            </h2>
            <div
              className={`mt-4 overflow-x-auto bg-white shadow-lg rounded-lg relative ${''
                }`}
            >
              <table className="min-w-full text-sm text-gray-600">
                <thead className="bg-gray-200 text-gray-800">
                  <tr>
                    <th className="py-3 px-6 text-left">Name</th>
                    <th className="py-3 px-6 text-left">Features</th>
                    <th className="py-3 px-6 text-left">Description</th>
                    <th className="py-3 px-6 text-left">Website</th>
                  </tr>
                </thead>
                <tbody>
                  {Idea.overallFeedback.Competition.ListCompetitors.map(
                    (item, i) => (
                      <tr key={i} className="border-t hover:bg-gray-50">
                        <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>{item.name}</td>
                        <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>{item.features}</td>
                        <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>{item.description}</td>
                        <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>
                          <a
                            href={item.link}
                            className="text-[rgb(100_65_233)] hover:underline"
                          >
                            Visit
                          </a>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              {!isSubscribed && (
                 <div className="absolute inset-0 bg-white/80 text-gray-600 flex flex-col justify-center items-center">
                 <p className="text-lg font-semibold text-center mb-4">
                   Subscribe to view the details
                 </p>
                 <button
                    onClick={UnlockFunction}
                   className="w-48 bg-[rgb(100_65_233)] text-white rounded-md text-lg font-medium hover:bg-[rgb(85_50_210)] focus:outline-none"
                 >
                   UnLock Now
                 </button>
               </div>
               
              )}
            </div>
          </div>
          {/* <div>
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              List of Competitors
            </h2>
            <div className="mt-4 overflow-x-auto bg-white shadow-lg rounded-lg">
              <table className="min-w-full text-sm text-gray-600">
                <thead className="bg-gray-200 text-gray-800">
                  <tr>
                    <th className="py-3 px-6 text-left">Name</th>
                    <th className="py-3 px-6 text-left">Features</th>
                    <th className="py-3 px-6 text-left">Description</th>
                    <th className="py-3 px-6 text-left">Website</th>
                  </tr>
                </thead>
                <tbody>
                  {Idea.overallFeedback.Competition.ListCompetitors.map(
                    (item, i) => (
                      <tr key={i} className="border-t hover:bg-gray-50">
                        <td className="py-3 px-6">{item.name}</td>
                        <td className="py-3 px-6">{item.features}</td>
                        <td className="py-3 px-6">{item.description}</td>
                        <td className="py-3 px-6">
                          <a
                            href={item.link}
                            className="text-[rgb(100_65_233)] hover:underline"
                          >
                            Visit
                          </a>
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
            </div>
          </div> */}

          <div>
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              Features Comparison
            </h2>
            {Array.isArray(Idea.overallFeedback.Comparison.ClientIdea) &&
              Idea.overallFeedback.Comparison.ClientIdea.length > 0 ? (
              <div className="mt-4 overflow-x-auto bg-white shadow-lg rounded-lg">
                <table className="min-w-full text-sm text-gray-600">
                  <thead className="bg-gray-200 text-gray-800">
                    <tr>
                      <th className="py-3 px-6 text-left">Your Features</th>
                      <th className="py-3 px-6 text-left">
                        Competitors Features
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {Idea.overallFeedback.Comparison.ClientIdea.map(
                      (item, i) => (
                        <tr key={i} className="border-t hover:bg-gray-50">
                          <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>{item}</td>
                          <td className={`py-3 px-6 ${!isSubscribed ? "blur-overlay" : ""}`}>
                            {Idea.overallFeedback.Comparison.Competitors[i] ||
                              "N/A"}
                          </td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <tr>
                <td colSpan={2} className="py-3 px-6 text-center text-gray-500">
                  No data available
                </td>
              </tr>
            )}
          </div>

          {/* Pros & Cons */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
                Pros
              </h2>
              <ul className="mt-4 list-disc pl-6 space-y-2 text-gray-600">
                {Idea.overallFeedback.Pros.map((pro, index) => (
                  <li key={index}>{pro}</li>
                ))}
              </ul>
            </div>
            <div className="p-6 bg-white shadow-lg rounded-lg">
              <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
                Cons
              </h2>
              <ul className="mt-4 list-disc pl-6 space-y-2 text-gray-600">
                {Idea.overallFeedback.Cons.map((con, index) => (
                  <li key={index}>{con}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* Solutions Feedback */}
          <div>
            <h2 className="text-lg font-semibold text-[rgb(100_65_233)]">
              Solutions Feedback
            </h2>
            {Idea.problemFeedbacks && Idea.problemFeedbacks.length > 0 ? (
              Idea.problemFeedbacks.map((solution, index) => (
                <div
                  key={index}
                  className="mt-6 p-6 bg-white shadow-lg rounded-lg"
                >
                  <h3 className="text-sm font-bold text-gray-800">
                    Solution {index + 1}:
                    <span className="ml-2 text-gray-600">
                      {solution.solutionStatement}
                    </span>
                  </h3>
                  <div className="mt-4 text-gray-600">
                    <p className="text-sm font-bold">Overview:</p>
                    <p className={`mt-2 ${!isSubscribed ? "blur-overlay" : ""}`}>
                      {solution.Overview || "No overview available."}
                    </p>
                    <p className="text-sm font-bold mt-4">Suggestions:</p>
                    <p className={`mt-2 ${!isSubscribed ? "blur-overlay" : ""}`}>
                      {solution.feedbackAndSuggestions ||
                        "No suggestions available."}
                    </p>
                    {solution.notableURLs &&
                      solution.notableURLs.length > 0 && (
                        <>
                          <p className="text-sm font-bold mt-4">Sources:</p>
                          <div className={`flex flex-wrap space-x-4 mt-4 ${!isSubscribed ? "blur-overlay" : ""}`}>
                            {solution.notableURLs.map((link, i) => (
                              <a
                                key={i}
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="px-3 py-1 border border-gray-300 rounded-full text-sm text-[rgb(100_65_233)] hover:bg-[rgb(100_65_233)] hover:text-white transition-colors"
                              >
                                {link.length > 30
                                  ? `${link.slice(0, 30)}...`
                                  : link}
                              </a>
                            ))}
                          </div>
                        </>
                      )}
                  </div>
                </div>
              ))
            ) : (
              <p className="mt-4 text-gray-600">
                No solutions feedback available.
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default App;
